import { type ReactNode } from 'react';
import { Trophy } from 'lucide-react';
import { Avatar } from '@/components/ui/avatar';
import { useMemberDisplay } from '@/hooks/use-member-display';
import { useAuth } from '@/hooks/use-auth';
import type { RaceBonusEntry } from '../hooks/use-race-bonus-current';

function WinnerRow({
  name,
  photo,
  youWon,
}: {
  name: string;
  photo?: string | undefined;
  youWon: boolean;
}): ReactNode {
  const tone = youWon ? 'text-success' : 'text-text-primary';
  return (
    <div className="flex items-center gap-sm">
      <Avatar name={name} size="xxs" src={photo} />
      <span className={`text-xs font-medium ${tone}`}>{name}</span>
      <span className="ml-auto flex items-center gap-1 text-[10px] font-medium uppercase tracking-wider text-text-tertiary/70">
        <Trophy size={11} className="text-brand-red" />
        Ganador
      </span>
    </div>
  );
}

export function RaceWinner({ race }: { race: RaceBonusEntry }): ReactNode {
  const { user } = useAuth();
  const winner = race.winner!;
  const display = useMemberDisplay(winner);
  const youWon = winner.id === user?.id;
  return (
    <WinnerRow name={display.name} photo={display.photo} youWon={youWon} />
  );
}
